import React, { useEffect, useState } from "react"
import "./RequestPackage.scoped.scss"
import { apiClient, urlClientInfo } from "../../../api"
import { Select, Button, notification, Spin } from "antd"
import TranserctionService from "../Service/transection"
import { packagelistPage, decryptMessage, CheckTokenExp, token, encryptMessage, omisekey } from "../../../config"
import queryString from "query-string"
import { useLocation, useHistory } from "react-router-dom"
import { PackageType, TransectionErrorType, TaxType, RequestFullTaxInvoice } from "../../../models/transection"
import TermsOfService from "../../../components/Modal/TermsOfService"
import PrivacyPolicy from "../../../components/Modal/PrivacyPolicy"
import AddTaxInfoModal from "./AddTaxInfoModal"
import TaxInvoiceModal from "./TaxInvoiceModal"
import ModalWarning from "../../../components/Ants/Modal/ModalWarning"
import ModalWarningIsOk from "../../../components/Ants/Modal/ModalWarningIsOk"

const paymentMethods = [
  { id: "PROM_PAY", name: "QR Code พร้อมเพย์", icon: "/img/payment-method/qr-code.png", color: "#4285f4" },
  // { id: "TRUE_MONEY", name: "True money", icon: "/img/payment-method/true-money.png", color: "#ff6b35" }, // Hiding for now
  { id: "CREDIT_CARD", name: "บัตรเครดิต/เดบิตการ์ด", icon: "/img/payment-method/card.png", color: "#333" },
  { id: "MOBILE_BANKING", name: "Mobile Banking", icon: "/img/payment-method/mobile-banking.png", color: "#ff4444" },
]

const bankOptions = [
  { id: "MOBILE_BANKING_KBANK", name: "K PLUS", bankLogoUrl: "/img/mobile-banking/mobile_banking_kbank.png" },
  { id: "MOBILE_BANKING_BAY", name: "KMA", bankLogoUrl: "/img/mobile-banking/mobile_banking_bay.png" },
  { id: "MOBILE_BANKING_BBL", name: "BBL", bankLogoUrl: "/img/mobile-banking/mobile_banking_bbl.png" },
  { id: "MOBILE_BANKING_KTB", name: "KTB", bankLogoUrl: "/img/mobile-banking/mobile_banking_ktb.png" },
  { id: "MOBILE_BANKING_SCB", name: "SCB Easy", bankLogoUrl: "/img/mobile-banking/mobile_banking_scb.png" },
]

const RequestPackageInfo = () => {
  const location = useLocation()
  const history = useHistory()
  const pid = queryString.parse(location.search)?.pid ? queryString.parse(location.search)?.pid : localStorage.getItem('pid');
  const type = queryString.parse(location.search)?.type ? queryString.parse(location.search)?.type : localStorage.getItem('type');

  const [selectedPackage, setSelectedPackage] = useState("")
  const [selectedPayment, setSelectedPayment] = useState("PROM_PAY")
  const [selectedBank, setSelectedBank] = useState("MOBILE_BANKING_KBANK")
  const [remarks, setRemarks] = useState("")
  const [fullTaxInvoice, setFullTaxInvoice] = useState(false)
  const [orderDetail, setOrderDetail] = useState({
    orderId: null,
    orderInvoiceId: null,
    packageName: null,
    packageType: null,
    packageCost: null,
    packageDetail: null,
    packageId: null,
    packageVat: null,
    packagegFee: null,
    packageTotal: null,
    packageIsActive: false,
    loading: false,
  })
  const [statusmessage, setStatusmessage] = useState("")
  const [openModalError, setOpenModalError] = useState(false)
  const [profile, setProfile] = useState({
    name: null,
    email: null,
  })
  const [openModal, setOpenModal] = useState("")
  const [taxInfoList, setTaxInfoList] = useState([])
  const [openAddTaxInfo, setOpenAddTaxInfo] = useState(false)
  const [openTaxInvoice, setOpenTaxInvoice] = useState(false)
  const [taxInfoId, setTaxInfoId] = useState(null)
  const [packageOptions, setPackageOptions] = useState([])
  const [clientInfo, setClientInfo] = useState({
    ipString: "",
    userAgent: "",
  })
  const [loading, setLoading] = useState(false)
  const [taxIsSelected, setTaxIsSelected] = useState(null)
  const [taxInfoData, setTaxInfoData] = useState(null)

  const getProfile = async () => {
    if (!CheckTokenExp()) {
      const req = null

      await apiClient.post('api/profile/GetProfile', req
        , {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        })
        .then(data => {
          var json = data.data[0]

          if (json) {
            setProfile({
              name: json.name,
              email: json.email,
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      history.push("/logout");
    }
  }

  const redirecttopackagelist = () => {
    history.push(packagelistPage);
  }

  const handleDecodeParam = async () => {
    const json = await getSettingJson();
    const envName = json?.env?.name;
    const decryptedMessage = decodeURIComponent(decryptMessage(pid, json?.encryptionEcomKey?.key, json?.encryptionEcomKey?.iv));
    const [packageId, price] = decryptedMessage.split("|");
    return { packageId, price, envName }
  }

  const handlePayment = async (cardToken = null) => {
    const taxInvoiceDefualt = taxInfoData ? taxInfoData : taxInfoList.find(row => row.isDefault)

    if (fullTaxInvoice && !taxInvoiceDefualt) {
      setOpenModalError(true)
      setStatusmessage("Please add tax invoice information")
      return
    }

    setLoading(true)
    const { packageId, price, envName } = await handleDecodeParam();

    const req = {
      "package_id": selectedPackage ? selectedPackage : type === "custom" ? "0" : packageId,
      ...(type === "custom" && { "package_price": price }),
      "package_type": orderDetail.packageType ? orderDetail.packageType : type === "custom" ? PackageType.CUSTOM : PackageType.DEFAULT,
      "payment_method": selectedPayment === "MOBILE_BANKING" ? selectedBank : selectedPayment, //type of payment
      "env": envName,
      "client": {
        "ipString": clientInfo.ipString,
        "userAgent": clientInfo.userAgent
      },
      ...(selectedPayment === "CREDIT_CARD" && { "card": cardToken }),
      "urlRedirect": window.location.origin,
      "Taxinvoice": {
        "type": fullTaxInvoice ? taxInvoiceDefualt.type : TaxType.INDIVIDUAL,
        "name": fullTaxInvoice ? taxInvoiceDefualt.name : profile.name,
        "mobile": fullTaxInvoice ? taxInvoiceDefualt.mobile : "",
        "idcard": fullTaxInvoice ? taxInvoiceDefualt.id_card : "",
        "address": fullTaxInvoice ? taxInvoiceDefualt.address : "",
        "branch": fullTaxInvoice ? taxInvoiceDefualt.branch : "",
        "province": fullTaxInvoice ? taxInvoiceDefualt.province : "",
        "district": fullTaxInvoice ? taxInvoiceDefualt.district : "",
        "subdistrict": fullTaxInvoice ? taxInvoiceDefualt.subdistrict : "",
        "post": fullTaxInvoice ? taxInvoiceDefualt.post : "",
        "new_taxvoice": false,
        "savedefault": fullTaxInvoice ? taxInvoiceDefualt.isDefault : false,
        "requestTax": fullTaxInvoice ? RequestFullTaxInvoice.Request : RequestFullTaxInvoice.NotRequest
      },
      "remark": remarks
    }

    await apiClient.post(`api/ecom/create-order`, req
      , {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
      .then(response => {
        if (response.data.status == 200) {
          history.push(`/OrderValidate?oid=${response.data.orderId}`);
        } else {
          setOpenModalError(true)
          setStatusmessage(response.data.message)
        }
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const paymentWithCreditCard = () => {
    const OmiseCard = window.OmiseCard;

    OmiseCard.configure({
      publicKey: omisekey, // replace with your real public key
      frameLabel: "ANTS",
      submitLabel: "Pay now",
      buttonLabel: "Pay with Card",
    });

    OmiseCard.attach();

    // Open the Omise card form
    OmiseCard.open({
      amount: orderDetail?.packageTotal * 100, // amount in satang (10000 satang = 100 THB)
      currency: "thb",
      onCreateTokenSuccess: (token) => {
        handlePayment(token);
      },
      onFormClosed: () => {
        console.log("Omise form closed");
      },
    });
  };

  const getOrderDetail = async () => {
    const { packageId, price, envName } = await handleDecodeParam();

    if (!selectedPackage && type === "custom") {

      const req = {
        "env": envName,
        "price": price,
        "payment_method": selectedPayment
      }
      await apiClient.post(`api/ecom/getPrice`, req,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            setOrderDetail({
              packageName: "Custom Package",
              packageType: PackageType.CUSTOM, //Custom type
              packageCost: response.data.data.price,
              packagegFee: response.data.data.fee,
              packageId: packageId,
              packageVat: Number(parseFloat(response.data.data.vat.replace(/,/g, '')).toFixed(2)),
              packageTotal: response.data.data.total,
              loading: false,
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      const req = {
        "env": envName,
        "package_id": selectedPackage ? selectedPackage : packageId,
        "payment_method": selectedPayment
      }
      await apiClient.post(`api/ecom/getPackageDetailById`, req,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            const isActive = response.data.data?.pkg_is_active;

            if (!isActive) {
              return history.push(packagelistPage);
            }

            setOrderDetail({
              packageName: response.data.data?.pkg_name,
              packageType: response.data.data?.pkg_type,
              packageCost: response.data.data?.pkg_price,
              packagegFee: response.data.data?.pkg_with_fee,
              packageDetail: response.data.data?.pkg_detail,
              packageId: response.data.data?.pkg_id,
              packageVat: response.data.data?.pkg_with_vat,
              packageTotal: response.data.data?.pkg_total,
              packageIsActive: response.data.data?.pkg_is_active,
              loading: false,
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }

  const getTaxInfo = async () => {
    if (CheckTokenExp()) {
      history.push("/logout");
    }

    let req = null

    apiClient
      .post("api/Ecom/getTaxinfos", req, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-type": "application/json; charset=UTF-8",
        },
      })
      .then((response) => {
        setTaxInfoList(response.data.taxinfos)
        if (response.data.status == 999) {
          return
        }
        if (response.data.status == 200 && response.data.taxinfos.length != 0) {
          setTaxInfoList(response.data.taxinfos)
        }
      })
      .catch((error) => {
        notification.open({
          message: "There is an error while trying to get Tax info data. ",
          description: "Please try again later",
          top: 60,
          className: "rti_form",
        })
      })
      .finally((data) => {
        // this.setState({
        //   loadingAll: false,
        // })
      })
  }

  const handleFullTaxInvoice = (value) => {
    setFullTaxInvoice(value)
    if (value) {
      getTaxInfo()
    }
  }

  const getPackageList = async () => {
    let req = null

    await apiClient.post("api/ecom/getPackagedata", req, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        const options = response.data.PackageList.map((row) => {
          return {
            id: row.PackageId,
            name: row.PackageName,
            price: row.Packagetotal_price,
            packageType: row.PackageType,
          }
        })
        setPackageOptions(options)
      })
      .catch((error) => { })
  }

  const getSettingJson = async () => {
    try {
      const response = await apiClient.get('api/function/getappsettings');
      return response.data;
    } catch (error) {
      console.log('Error fetching JSON:', error);
      return null;
    }
  }

  const handleChangePackage = async (value) => {
    const selected = packageOptions.find(option => option.id === value);
    setSelectedPackage(selected.id)
  }

  const handleChangePaymentMethod = async (value) => {
    setSelectedPayment(value)
  }

  const getClientInfo = () => {
    urlClientInfo
      .get("", {
        headers: { "Content-type": "application/json; charset=UTF-8" },
      })
      .then((response) => {
        setClientInfo({
          ipString: response.data.ipString,
          userAgent: response.data.userAgent,
        })
      })
      .catch((error) => {
        this.setState({ clientInfo: "" })
      })
  }

  const handleCloseModal = () => {
    setOpenModalError(false);
  };

  useEffect(() => {
    getSettingJson()
    getPackageList()
    getProfile()
    getClientInfo()
  }, [])

  useEffect(() => {
    getOrderDetail();
  }, [selectedPackage, selectedPayment]);

  return (
    <Spin spinning={loading} >
      <div className="request-package-container">
        <div className="payment-container">
          <div className="payment-cards">
            {/* Left Card - Package Selection */}
            <div className="card package-card">
              <h2 className="card-title">Your selected package</h2>

              <div className="form-group">
                <label>Package</label>
                <Select
                  value={selectedPackage ? packageOptions.find(option => option.id === selectedPackage)?.name : packageOptions.find(option => option.id === orderDetail.packageId)?.name ? packageOptions.find(option => option.id === orderDetail.packageId)?.name : "Custom Package"}
                  style={{ height: "40px" }}
                  onChange={(value) => handleChangePackage(value)}
                  options={packageOptions}
                >
                  {packageOptions.map((option) => (
                    <Select.Option key={option.id} value={option.id} price={option.price}>
                      {option.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>

              <div className="price-section">
                <div className="price-label">Price</div>
                <div className="price-value">{orderDetail?.packageCost?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
              </div>

              <div className="breakdown">
                <div className="breakdown-item">
                  <span>Subtotal</span>
                  <span>{orderDetail?.packageCost?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Baht</span>
                </div>
                <div className="breakdown-item">
                  <span>Fee</span>
                  <span>{orderDetail?.packagegFee?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Baht</span>
                </div>
                {orderDetail?.packageVat > 0 && (
                  <div className="breakdown-item">
                    <span>VAT 7%</span>
                    <span>{orderDetail?.packageVat?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Baht</span>
                  </div>
                )}
              </div>

              <div className="net-amount">
                <div className="net-label">NET AMOUNT</div>
                <div className="net-value">{orderDetail?.packageTotal?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Baht</div>
              </div>

              <div className="form-group">
                <label>Remark</label>
                <textarea
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Please enter your remarks"
                  className="textarea-input"
                  rows={4}
                />
              </div>
            </div>

            {/* Right Card - Payment Method */}
            <div className="card payment-card">
              <h2 className="card-title">Selected payment method</h2>

              <div className="payment-methods">
                {paymentMethods.map((method) => (
                  <label key={method.id} className="payment-option">
                    <input
                      type="radio"
                      name="payment"
                      value={method.id}
                      checked={selectedPayment === method.id}
                      onChange={(e) => handleChangePaymentMethod(e.target.value)}
                    />
                    <img src={method.icon} alt={method.name} className="payment-logo" />
                    <span className="payment-name">{method.name}</span>
                  </label>
                ))}
              </div>

              {selectedPayment === "MOBILE_BANKING" && (
                <div className="bank-options">
                  {bankOptions.map((bank) => (
                    <label key={bank.id} className="bank-option">
                      <input
                        type="radio"
                        name="bank"
                        value={bank.id}
                        checked={selectedBank === bank.id}
                        onChange={(e) => setSelectedBank(e.target.value)}
                      />
                      <img src={bank.bankLogoUrl} alt={bank.name} className="bank-logo" />
                      <span className="bank-badge">
                        {bank.name}
                      </span>
                    </label>
                  ))}
                </div>
              )}

              <div className="invoice-section">
                <h3 className="invoice-title">Invoice information</h3>

                <label className="checkbox-option">
                  <input type="checkbox" checked={fullTaxInvoice} onChange={(e) => handleFullTaxInvoice(e.target.checked)} />
                  <span>Full Tax Invoice</span>
                </label>

                {!fullTaxInvoice ? (
                  <div className="contact-info">
                    <div className="info-item">
                      <span className="info-label">Contact name:</span>
                      <span className="info-value">{profile?.name}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Email:</span>
                      <span className="info-value">{profile?.email}</span>
                    </div>
                  </div>
                ) : (
                  <div className="add-tax-info">
                    <div className="tax-info-details">
                      {taxInfoData ? (
                        <div className="option-details" key={taxInfoData?.id}>
                          <div className="company-name">{taxInfoData?.name}</div>
                          <div className="detail-line">ID Card : {taxInfoData?.id_card}</div>
                          <div className="detail-line">
                            {taxInfoData?.address}{" "}
                            {taxInfoData?.proinve === "กรุงเทพมหานคร" ? "แขวง" : "ตำบล"}{" "}{taxInfoData?.district}{" "}
                            {taxInfoData?.proinve === "กรุงเทพมหานคร" ? "เขต" : "อำเภอ"}{" "}{taxInfoData?.subdistrict}{" "}
                            {taxInfoData?.proinve}{" "}{taxInfoData?.post}
                          </div>
                          <div className="detail-line">{taxInfoData?.mobile}</div>
                        </div>
                      ) : (
                        taxInfoList.length > 0 && (
                          taxInfoList.map((row) => (
                            row.isDefault && (
                              <div className="option-details" key={row.id}>
                                <div className="company-name">{row.name}</div>
                                <div className="detail-line">ID Card : {row.id_card}</div>
                                <div className="detail-line">
                                  {row.address}{" "}
                                  {row.proinve === "กรุงเทพมหานคร" ? "แขวง" : "ตำบล"}{" "}{row.district}{" "}
                                  {row.proinve === "กรุงเทพมหานคร" ? "เขต" : "อำเภอ"}{" "}{row.subdistrict}{" "}
                                  {row.proinve}{" "}{row.post}
                                </div>
                                <div className="detail-line">{row.mobile}</div>
                              </div>
                            )
                          ))
                        )
                      )}

                      {taxInfoList.length > 0 ? (
                        <Button type="primary" className="btn-add-tax-info" onClick={() => setOpenTaxInvoice(true)}
                        >
                          Change information
                        </Button>
                      ) : (
                        <Button type="primary" className="btn-add-tax-info" onClick={() => setOpenAddTaxInfo(true)} >
                          Add information
                        </Button>
                      )}
                    </div>
                  </div>
                )}

                <div className="terms">
                  <p>
                    By continuing, you agree to Platform's{" "}
                    <span className="terms-link" onClick={() => setOpenModal("terms")}>
                      Terms of Service
                    </span>{" "}
                    and acknowledge you've read our{" "}
                    <span className="privacy-link" onClick={() => setOpenModal("policy")}>
                      Privacy Policy
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="payment-footer">
          <div className="payment-footer-item">
            <Button type="primary" className="btn-cancel" onClick={() => redirecttopackagelist()}>
              Cancel
            </Button>
          </div>
          <div className="payment-footer-item">
            <Button type="primary" className="btn-pay" onClick={() => selectedPayment === "CREDIT_CARD" ? paymentWithCreditCard() : handlePayment()}>
              Pay
            </Button>
          </div>
        </div>
        <TermsOfService open={openModal === "terms"} setOpen={setOpenModal} />
        <PrivacyPolicy open={openModal === "policy"} setOpen={setOpenModal} setIsAgree={() => setOpenModal(false)} />

        {/* Add tax info modal */}
        <AddTaxInfoModal
          isOpen={openAddTaxInfo}
          onClose={() => setOpenAddTaxInfo(false)}
          taxInfoList={taxInfoList}
          taxInfoId={taxInfoId}
          getTaxInfo={getTaxInfo}
        />

        {/* Tax Invoice modal */}
        <TaxInvoiceModal
          isOpen={openTaxInvoice}
          onClose={() => setOpenTaxInvoice(false)}
          openAddNew={() => setOpenAddTaxInfo(true)}
          taxInfoList={taxInfoList}
          setTaxInfoId={setTaxInfoId}
          getTaxInfo={getTaxInfo}
          taxIsSelected={taxIsSelected}
          setTaxIsSelected={setTaxIsSelected}
          setTaxInfoData={setTaxInfoData}
          taxInfoData={taxInfoData}
        />

        <ModalWarningIsOk
          loading={loading}
          warningModalVisible={openModalError}
          warningModal={() => setOpenModalError(false)}
          message={statusmessage}
          messageSuccess={""}
          closemodal={() => handleCloseModal()}
        />
      </div >
    </Spin>
  )
}

export default RequestPackageInfo